<template>
  <div>
    <div class="loader" v-show="!loaded"></div>
    <div class="panel panel-default">
      <div class="panel-heading">Дни доставки</div>

      <div class="panel-body">
        <form>
          <div class="form-group row col-md-4 mb-3">
            <label for="deliveryDate">Выбирите дату</label>
            <input type="date" class="form-control" id="deliveryDate" placeholder="Дата доставки" v-model="deliveryDate" @change="refreshDeliveryDays()">
            <button type="button" class="btn btn-primary" style="margin-top: 15px;" @click="disableDay(deliveryDate)">Отключить эту дату</button>
          </div>

          <div style="clear:both;"></div>

          <h4>Для нижеперечисленных дней, при оформлении заказа, дата доставки недоступна для выбора:</h4>
          <div class="form-group row col-md-4 mb-3" style="margin-top: 15px;">
            <div class="form-check" v-for="(item, key) in disabledDays">
              {{item.day}}
              <a href="#" @click.prevent="deleteDay(item.id)">удалить</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {api} from '../http'
var config = require('../config')

export default {
  mounted () {
  },
  data () {
    return {
      url: config.appUrl,
      loaded: false,
      data: [],
      disabledDays: [],
      deliveryDate: (new Date()).toJSON().slice(0, 10)
    }
  },
  beforeCreate () {
    this.loaded = false
    api.post('settings/fetchDeliveryDays').then(response => {
      this.loaded = true
      this.disabledDays = response.data
    })
  },
  methods: {
    refreshDeliveryDays () {
      this.loaded = false
      api.post('settings/fetchDeliveryDays').then(response => {
        this.loaded = true
        this.disabledDays = response.data
      })
    },
    disableDay (val) {
      this.loaded = false
      var formData = new FormData()
      formData.append('delivery_date', val)
      api.post('settings/storeDeliveryDay', formData).then(response => {
        this.loaded = true
        this.disabledDays = response.data
      })
    },
    deleteDay (id) {
      this.loaded = false
      var formData = new FormData()
      formData.append('id', id)
      api.post('settings/deleteDeliveryDay', formData).then(response => {
        this.loaded = true
        this.disabledDays = response.data
      })
    }
  }
}
</script>

<style>
.loader {
  background-color: rgba(255, 255, 128, .5);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminSettings/AdminSettingsDeliveryDay.vue